import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  selectedTab: 'Incomplete',
  currentPage: 1,
  searchQuery: '',
};

const leadListPayloadSlice = createSlice({
  name: 'leadListPayload',
  initialState,
  reducers: {
    setPayLoadValue: (state, action) => {
      // Spread action.payload to update the state partially
      return {
        ...state,
        ...action.payload,
      };
    },
    resetPayLoadValue: () => initialState,
  },
});

export const {setPayLoadValue, resetPayLoadValue} =
  leadListPayloadSlice.actions;

export default leadListPayloadSlice.reducer;
